import React from "react";
import "./tokeninfo.css";
import { Input } from "@chakra-ui/react";
import { Select } from "@chakra-ui/react";

const TokenInfoSec = ({ formValues, setFormValues }) => {
  return (
    <div>
      <div className="linethrough">TOKEN INFORMATION</div>
      <div className="formholder">
        <div className="row1">
          <div className="inp1">
            <label htmlFor="tokenname">Name <span className="astrick">*</span></label>
            <Input
              placeholder="TokenName (BINANCE Coin)"
              size="sm"
              onChange={(e) => {
                setFormValues({ ...formValues, tokenName: e.target.value });
              }}
            />
          </div>
          <div className="inp2">
            <label htmlFor="tokensymbol">Symbol <span className="astrick">*</span></label>
            <Input
              placeholder="Token Symbol (BNB)"
              size="sm"
              onChange={(e) => {
                setFormValues({ ...formValues, tokenSymbol: e.target.value });
              }}
            />
          </div>
          <div className="inp3">
            <label htmlFor="totalsupply">Totalsupply <span className="astrick">*</span></label>
            <Input
              placeholder="Min 1000"
              size="sm"
              onChange={(e) => {
                setFormValues({
                  ...formValues,
                  tokenTotalSupply: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="row2">
          <label htmlFor="tokensymbol">Router <span className="astrick">*</span></label>
          <div>
            <Select
              size="sm"
              onChange={(e) => {
                setFormValues({ ...formValues, router: e.target.value });
              }}
            >
              <option value="option1">Pancakeswap</option>
            </Select>
          </div>
        </div>
        <div className="row3">
          <div className="inp1">
            <label htmlFor="tokenname">Telegram <span className="astrick">*</span></label>
            <Input placeholder="https://t.me/..." size="sm" 
            onChange={(e) => {
                setFormValues({ ...formValues, telegram: e.target.value });
              }}/>
          </div>
          <div className="inp2">
            <label htmlFor="tokensymbol">Website <span className="astrick">*</span></label>
            <Input placeholder="https://www..." size="sm" 
            onChange={(e) => {
                setFormValues({ ...formValues, website: e.target.value });
              }}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenInfoSec;
